// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"e627b865","268":"416dc699"}[chunkId] + ".chunk.js";
};